import React from 'react';
import Select from 'react-select';

const InputSelect = ({ label, options, register, errors, validation }) => {
  // Handle changes when user selects an option
  const handleChange = (selectedOption) => {
    register(validation.name).onChange({
      target: {
        name: validation.name,
        value: selectedOption ? selectedOption.value : '',
      },
    });
  };

  return (
    <div className="mb-4">
      <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center">
        <label className="block font-medium mb-2 md:mb-0 mr-2 w-max">{label}</label>
        <div className="w-full xl:max-w-[300px]">
          <Select
            options={options}
            onChange={handleChange} // Handle option change
            placeholder="Pilih..."
            className={`react-select-container ${
              errors[validation.name] ? 'border-red' : 'border-borderGray'
            }`}
            classNamePrefix="react-select"
          />
        </div>
      </div>
      {errors[validation.name] && (
        <p className="text-red text-right mt-2">
          {errors[validation.name].message}
        </p>
      )}
    </div>
  );
};

export default InputSelect;
